import script from "./Preview.vue?vue&type=script&lang=ts&setup=true"
export * from "./Preview.vue?vue&type=script&lang=ts&setup=true"

export default script